import { Link } from "react-router-dom/cjs/react-router-dom.min";
import axios from 'axios';
import { useContext, useEffect, useState } from "react";
import MyContext from "../MyContext";
import "./DaySummary.scss"
import FullWidthContainer from "./FullWidthContainer";
import ArrayDisplayContainer from "./ArrayDisplayContainer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";



function DaySummary() {
  const [data, setData] = useState('');
  const [date, setDate] = useState(new Date());
  const [executives, setExecutives] = useState([]);
  const [executive, setExecutive] = useState('');


  const { loading, user_details, currency } = useContext(MyContext);
  const fetchData = async (date) => {
    const request_data = new FormData();
    request_data.append('sid', user_details.sid);
    request_data.append('date',new Date(date).toLocaleDateString('en-CA'));
    request_data.append('executive',executive.value??'');
    const url = `${process.env.REACT_APP_SSS}/api/getDaySummary`;
    try {
      const response = await axios.post(url, request_data);
      setData(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      loading(0);
    }
  };
  useEffect(() => {
    loading(1);
    getExecutives();
  }, []);

  useEffect(() => {
    loading(1);
    fetchData(date);
  }, [date,executive]);

  const componentsData = [
    { title: "Executive", value: data?.employee_name},
    { title: "Date", value: data?.curr_date },
    { title: "Routes", index: 'route_name', value: data?.routes },
    // { title: "Distributors", index: 'name', value: data?.distributors },
    { title: "Distance Covered", value: data?.distance, unit:'distance'},
    { title: "Total Calls", value: data?.total_call, unit: 'count' },
    { title: "Productive Calls", value: data?.productive_calls, unit: 'count' },
    { title: "Order Value", value: data?.order_value, unit: 'amount' },
    { title: "TLS", value: data?.tls_items, unit: 'count' },
    { title: "Market Spend Time", value: data?.market_spend_time, },
    { title: "Joint Visit", value: data?.joint_visit_flag, },
  ];
  const onDateChange = (date) =>{
    setDate(date)
  }
  const onExecutiveChange = (value) =>{
    setExecutive(value)
  }
  const getExecutives = () =>{
    const url = `${process.env.REACT_APP_SSS}/api/get/executives`;
    loading(1);
    $.ajax({
      url : url,
      data : {
        sid : user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        setExecutives(return_data.executives);
        loading(0);
      }else{
        loading(0);
      }
     }).fail(function(){
      alert("Network error");
      loading(0);
    });
  }
    
  const jointVisitWith = { title: "Joint Visit With", value: data?.joint_visits, index: 'staff_name' };
  const jointVisitScheduled = { title: "Joint Visit Created with", value: data?.joint_visit_scheduled, index: 'staff_name' };

  return (
    <div className="day_summary_dashboard_page_container">
      <div className="page_header">
        
        <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{marginRight: '15px', cursor: 'pointer'}}></i> Day Summary</div>
      </div>
      <form className="month_select_form">
        <div className="blocks">
          <div className="input_grid">
            <div className="input_label">Date</div>
            <DatePicker
              selected={date}
              // value={date}
              onChange={onDateChange}
              dateFormat=" dd / MM / y"
              type="text"
              size="sm"
              className="datepicker-custom-style"
              dropdownMode="select"
              minDate={new Date(new Date().getFullYear(), new Date().getMonth() - 3, 1)}
              maxDate={new Date()}
            />
          </div>
          <div className="input_grid">
            <div className="input_label">Executive</div>

            {/* <div className="input_grid"> */}
              <Select
                options={executives}
                value={executive}
                className="executive"
                // ref={this.executiveSelect}
                onChange={onExecutiveChange}
                required
              />
          </div>
        </div>

      </form>
      <div>
        {
          componentsData.map((item, index) => (
            item.index ? (
              <ArrayDisplayContainer key={index}
                {...item}
                currency={currency}
              />
            ) : (
              <FullWidthContainer key={index}
                {...item}
                currency={currency}
              />
            )
          ))
        }
        {
          (user_details.route_plan=='1' && data.joint_visit_flag) ?<ArrayDisplayContainer {...jointVisitWith} />:undefined
        }
        {
          user_details.joint_visit=='1'?<ArrayDisplayContainer {...jointVisitScheduled} />:undefined
        }
      </div>
    </div>
  )
}

export default DaySummary;